import {createAction} from "redux-act";
import {IUser} from "modules/reducers";
import {IFormError} from "modules/types";

export interface IRegisterPayload {
	firstName: string;
	lastName: string;
	username: string;
	email: string;
	password: string;
	favoriteTeam: number;
	country: string;
	locationCode?: string;
	termsGZ: boolean;
	optInGZ: boolean;
	ageOptIn: boolean;
	lang: string;
}

export interface ILoginPayload {
	email: string;
	password: string;
}

export interface IForgotPasswordPayload {
	email: string;
}

export interface IRecoveryPasswordPayload {
	password: string;
	token: string;
}

export interface IValidateTokenPayload {
	token: string;
}

export const register = createAction<IRegisterPayload>();
export const userRegisterSuccess = createAction<IUser>();
export const userRegisterFailed = createAction<IFormError>();

export const login = createAction<ILoginPayload>();
export const userLoginSuccess = createAction<IUser>();
export const userLoginFailed = createAction<IFormError>();

export const forgotPassword = createAction<IForgotPasswordPayload>();
export const forgotPasswordSuccess = createAction();
export const forgotPasswordFailed = createAction<IFormError>();

export const recoveryPassword = createAction<IRecoveryPasswordPayload>();
export const recoveryPasswordSuccess = createAction();
export const recoveryPasswordFailed = createAction<IFormError>();

export const validateToken = createAction<IValidateTokenPayload>();
export const validateTokenSuccess = createAction();
export const validateTokenFailed = createAction();

export const logout = createAction();
export const userLogoutSuccess = createAction();
export const userLogoutFailed = createAction();

export const setRedirectUri = createAction<string>();
export const nonAuthRedirect = createAction();
